import Chart from 'react-apexcharts'
import {useSelector} from 'react-redux'
import {colors} from '../../../utils/colors'
import {useEffect, useState} from 'react'
import localStorageManager from '../../../utils/localStorageManager'
import localStorageKeys from '../../../utils/localStorageKeys'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const DonutChart = ({id, isDarkMode}) => {
    const text = useNamespaceTranslations('monitoring')
    const uptime = useSelector(state => state.monitoring.uptime)
    const data = useSelector(state => state.monitoring.data)
    const series = uptime ? [uptime.up, uptime.down] : [100, 0]
    const [isFirstRender, setIsFirstRender] = useState(true)
    const newResourceId = localStorageManager.get(localStorageKeys.CREATED_RESOURCES)?.[id]

    useEffect(() => {
        setIsFirstRender(false)
    }, [data])

    useEffect(() => {
        if (newResourceId) {
            setIsFirstRender(true)
        }
    }, [])

    const options = {
        colors: [colors.colorGreen, colors.colorRosePink],
        labels: [`Up time <b>(${data?.length ? `${uptime?.up ?? 100}%` : (isFirstRender ? '100%' : text.not_available)})</b>`, `Down time <b>(${data?.length ? `${uptime?.down || 0}%` : (isFirstRender ? '0%' : text.not_available)})</b>`],
        chart: {
            fontFamily: 'SpaceGrotesk, sans-serif',
            toolbar: {
                show: true
            },
            events: {
                mounted: chart => {
                    chart.windowResizeHandler()
                }
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '80%'
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            position: 'bottom',
            labels: {
                colors: isDarkMode ? colors.colorWhite : colors.colorPrimary,
                useSeriesColors: false
            }
        },
        fill: {
            type: 'solid',
            colors: [colors.colorGreen, colors.colorRosePink]
        },
        stroke: {
            show: false
        }
    }
    return (
        <div>
            <Chart
                options={options}
                series={series}
                type="donut"
                height={300}
            />
        </div>
    )
}

export default DonutChart
